import { render, staticRenderFns } from "./UsersTab.vue?vue&type=template&id=793ebbee&scoped=true"
import script from "./UsersTab.ts?vue&type=script&lang=ts&external"
export * from "./UsersTab.ts?vue&type=script&lang=ts&external"
import style0 from "./UsersTab.vue?vue&type=style&index=0&id=793ebbee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ebbee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793ebbee')) {
      api.createRecord('793ebbee', component.options)
    } else {
      api.reload('793ebbee', component.options)
    }
    module.hot.accept("./UsersTab.vue?vue&type=template&id=793ebbee&scoped=true", function () {
      api.rerender('793ebbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/tabs/UsersTab/UsersTab.vue"
export default component.exports